export default function Testimonials() {
  const testimonials = [
    {
      name: '小A',
      platform: '微博',
      content: '自从关注了51暗网，每天吃瓜吃到撑！爆料速度太快了，很多新闻都是我先从这里看到，然后才上热搜的。真的是一手消息源！',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20portrait%20avatar%20with%20warm%20tones%2C%20simple%20clean%20background%2C%20modern%20illustration%20style%2C%20flat%20design%20with%20subtle%20gradients%2C%20Chinese%20young%20adult%20vibe&width=80&height=80&seq=testimonial-avatar-01&orientation=squarish',
    },
    {
      name: '大B哥',
      platform: '知乎',
      content: '作为追星十年的老粉，我不得不说51暗网的爆料质量是真的高。不是那种捕风捉影的标题党，很多料最后都被证实了。信息很靠谱。',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20avatar%2C%20warm%20amber%20and%20coral%20tones%2C%20clean%20background%2C%20modern%20flat%20illustration%20style%2C%20young%20Chinese%20male%20vibe%2C%20simple%20geometric%20shapes&width=80&height=80&seq=testimonial-avatar-02&orientation=squarish',
    },
    {
      name: '吃瓜群众C',
      platform: '小红书',
      content: '每天必刷的网站！界面干净、更新及时、内容劲爆但不低俗。身边的朋友都被我安利了，现在大家都是51暗网的忠实用户。',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20portrait%20avatar%2C%20warm%20pink%20and%20peach%20tones%2C%20simple%20clean%20background%2C%20modern%20illustration%20style%2C%20young%20Chinese%20female%20vibe%2C%20flat%20design&width=80&height=80&seq=testimonial-avatar-03&orientation=squarish',
    },
    {
      name: '娱乐老司机',
      platform: '豆瓣',
      content: '追八卦十年，见证过无数平台的起起落落。51暗网是我见过最专业的爆料平台，编辑团队真的很用心在维护内容质量。强烈推荐！',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20portrait%20avatar%2C%20warm%20crimson%20and%20burgundy%20tones%2C%20clean%20background%2C%20modern%20flat%20illustration%20style%2C%20mature%20Chinese%20male%20vibe%2C%20simple%20shapes&width=80&height=80&seq=testimonial-avatar-04&orientation=squarish',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium border border-primary-300 text-primary-700 bg-primary-50 mb-4">
            用户口碑
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-900">
            大家怎么说
          </h2>
          <p className="text-foreground-600 text-sm mt-2">来自真实用户的评价</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-5xl mx-auto">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-background-50 rounded-lg border border-background-200/70 p-6">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatarUrl}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-bold text-foreground-900">{t.name}</p>
                  <span className="text-[11px] text-accent-600 bg-accent-50 px-1.5 py-0.5 rounded-full">
                    {t.platform}用户
                  </span>
                </div>
                <div className="ml-auto flex text-accent-500">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs"></i>
                  ))}
                </div>
              </div>
              <div className="text-foreground-700 text-3xl font-heading leading-none mb-2 opacity-20">
                &ldquo;
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}